import { types } from "../Helpers/Types";

const initialState = {
  temperatura: "",
  icono: "",
};

export const ClimaReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.clima: {
      return {
        temperatura: action.payload.temperatura,
        icono: action.payload.icono,
      };
    }

    default:
      return state;
  }
};
